import { EMAIL, PHONE, PHONE_VISIT, ADDRESS, WHATSAPP_URL } from '../data/siteData';

function FooterIcon({ d, fill = false }) {
  return (
    <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill={fill ? "currentColor" : "none"} stroke={fill ? "none" : "currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d={d} />
    </svg>
  );
}

export default function Footer({ setPage }) {
  const go = (page) => { setPage(page); window.scrollTo({ top: 0, behavior: 'smooth' }); };

  return (
    <footer className="bg-navy-deep pt-16 pb-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">

          {/* Brand */}
          <div className="lg:col-span-2">
            <button onClick={() => go('home')} className="block mb-5 focus:outline-none">
              <img src="/travizon-logo-white.png" alt="Travizon Migration" className="h-11 w-auto object-contain" style={{filter:'drop-shadow(0 1px 4px rgba(0,0,0,0.4))'}} />
            </button>
            <p className="text-white/40 text-xs leading-relaxed max-w-[300px] mb-5">Pakistan's trusted visa and migration consultancy. Study abroad in 35+ countries. Scholarships. Insurance. Skilled migration. Digital nomad visas. Full journey support from Lahore.</p>

            {/* Contact mini-list */}
            <div className="flex flex-col gap-2.5">
              <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/50 hover:text-teal text-xs transition-colors">
                <svg className="w-3.5 h-3.5 fill-current flex-shrink-0" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/></svg>
                {PHONE}
              </a>
              <a href="tel:03210784000" className="flex items-center gap-2 text-white/50 hover:text-teal text-xs transition-colors">
                <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z" /></svg>
                {PHONE_VISIT} (Visit Visa)
              </a>
              <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 text-white/50 hover:text-teal text-xs transition-colors">
                <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                {EMAIL}
              </a>
              <div className="flex items-start gap-2 text-white/40 text-xs">
                <svg className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                {ADDRESS}
              </div>
            </div>

            <div className="flex gap-2 mt-5">
              {[
                { href: 'https://www.facebook.com/travizon1', label: 'Facebook', d: 'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z' },
                { href: 'https://www.instagram.com/travizon1', label: 'Instagram', d: 'M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01M6.5 19.5h11a3 3 0 003-3v-11a3 3 0 00-3-3h-11a3 3 0 00-3 3v11a3 3 0 003 3z' },
                { href: 'https://www.linkedin.com/company/105082201', label: 'LinkedIn', d: 'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z' },
              ].map(({ href, label, d }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}
                  className="w-9 h-9 rounded-full bg-white/6 flex items-center justify-center text-white/40 hover:bg-teal hover:text-white transition-all duration-200">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d={d} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h5 className="text-[0.7rem] tracking-[0.15em] uppercase text-white/30 font-semibold mb-5">Services</h5>
            <ul className="flex flex-col gap-2.5">
              {[['Study Abroad','services'],['Skilled Migration','migration'],['Digital Nomad Visa','services'],['Visit Visa','services'],['Scholarships','scholarships'],['Insurance','insurance'],['Accommodation','services'],['Value Added Services','value-added']].map(([l,p]) => (
                <li key={l}><button onClick={() => go(p)} className="text-white/45 text-xs hover:text-white transition-colors text-left flex items-center gap-1.5 group">
                  <span className="w-1 h-1 rounded-full bg-teal/40 group-hover:bg-teal transition-colors flex-shrink-0"></span>{l}
                </button></li>
              ))}
            </ul>
          </div>

          {/* Destinations */}
          <div>
            <h5 className="text-[0.7rem] tracking-[0.15em] uppercase text-white/30 font-semibold mb-5">Top Destinations</h5>
            <ul className="flex flex-col gap-2.5">
              {['United Kingdom 🇬🇧','Canada 🇨🇦','Australia 🇦🇺','USA 🇺🇸','Germany 🇩🇪','Sweden 🇸🇪','Finland 🇫🇮','Italy 🇮🇹','Austria 🇦🇹'].map(d => (
                <li key={d}><button onClick={() => go('destinations')} className="text-white/45 text-xs hover:text-white transition-colors text-left">{d}</button></li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h5 className="text-[0.7rem] tracking-[0.15em] uppercase text-white/30 font-semibold mb-5">Company</h5>
            <ul className="flex flex-col gap-2.5">
              {[['About Us','about'],['Our Team','team'],['Success Stories','stories'],['FAQ','faq'],['Contact Us','contact']].map(([l,p]) => (
                <li key={l}><button onClick={() => go(p)} className="text-white/45 text-xs hover:text-white transition-colors text-left">{l}</button></li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/6 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <img src="/travizon-logo-white.png" alt="Travizon" className="h-5 w-auto object-contain opacity-25" />
            <p className="text-white/25 text-[0.65rem]">© 2025 Travizon Migration. All rights reserved.</p>
          </div>
          <p className="text-white/15 text-[0.6rem] text-center">All visa decisions rest solely with respective immigration authorities. Travizon provides guidance only.</p>
        </div>
      </div>
    </footer>
  );
}
